import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import { analyticService } from 'global/services';

import { Mobile, Desktop } from 'app/components/Responsive';
import { isAdressWithHouseSelected } from 'app/utils/address';
import { AddressSuggestions } from './AddressSuggestions';

// eslint-disable-next-line
import inputStyles from '../inputs.scss';
// eslint-disable-next-line
import streetStyles from './streetinput.scss';


const SUGGESTS_MIN_HEIGHT = 61;
const SUGGESTS_MAX_HEIGHT = 320;

const canSetHighlightedIndex = (index, suggestions) => index >= 0 && index < suggestions.length;


class StreetInput extends React.PureComponent {
    inputRef = React.createRef();

    state = {
        isShowSuggestion: false,
        highlightedIndex: 0,
    };

    streetListRef = React.createRef();

    scrollbarsRef = React.createRef();

    componentDidUpdate(prevProps) {
        const { suggestions } = this.props;
        const { suggestions: prevSuggestions } = prevProps;
        if (suggestions !== prevSuggestions) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                highlightedIndex: 0,
            });
        }
    }

    handleCloseSuggestion = () => {
        this.setState({
            isShowSuggestion: false,
        });
    };

    handleCloseOutSuggestion = () => {
        const { suggestions } = this.props;
        const haveOnlyOneSuggestions = suggestions.length === 1;
        if (haveOnlyOneSuggestions) {
            const [item] = suggestions;
            this.handleSelectStreet(item);
        }
        this.handleCloseSuggestion();
    };

    handleChangeStreet = (e) => {
        const { onChange } = this.props;
        const { target: { value } } = e;

        onChange(value);

        if (value !== '') {
            this.setState({
                isShowSuggestion: true,
            });
        } else {
            this.handleCloseSuggestion();
        }
    };

    handleBlurStreet = () => {
        const { onBlur } = this.props;
        onBlur();
    };

    handleClickStreet = () => {
        analyticService.push({ eventName: 'Checkout_Click_Address', eventLocation: '/checkout' });
        const { onClick } = this.props;
        onClick();
    };

    handleSelectStreet = (item) => {
        const { onSelect, onChange, suggestions } = this.props;
        const { value } = item;
        const haveOnlyOneSuggestions = suggestions.length === 1;

        onSelect(item);

        if (isAdressWithHouseSelected(item) || haveOnlyOneSuggestions) {
            this.handleCloseSuggestion();
        } else {
            onChange(`${value} `);
            if (this.inputRef.current) {
                this.inputRef.current.focus();
            }
        }
    };

    handleKeyDown = (e) => {
        const { suggestions } = this.props;
        const { highlightedIndex } = this.state;

        const haveSuggestions = suggestions.length >= 1;
        if (!haveSuggestions) return;

        switch (e.keyCode) {
            case 40: // down
                e.preventDefault();
                this.highlightNextOption();
                break;
            case 38: // up
                e.preventDefault();
                this.highlightPrevOption();
                break;
            case 9: // tab
            case 13: // enter
                this.handleSelectStreet(suggestions[highlightedIndex]);
                break;
            default:
        }
    };

    highlightNextOption() {
        const { highlightedIndex } = this.state;
        this.highlightOption(highlightedIndex + 1);
    }

    highlightPrevOption() {
        const { highlightedIndex } = this.state;
        this.highlightOption(highlightedIndex - 1);
    }

    highlightOption(index) {
        const { suggestions } = this.props;
        if (!canSetHighlightedIndex(index, suggestions)) return;

        this.setState({
            highlightedIndex: index,
        });

        const highlightedNode = this.streetListRef.current.childNodes[index];
        const scrollbars = this.scrollbarsRef.current;
        const height = highlightedNode.clientHeight;
        const offset = highlightedNode.offsetTop;
        const needScrollToBottom = offset + height > SUGGESTS_MAX_HEIGHT;
        const needScrollToTop = offset < SUGGESTS_MAX_HEIGHT && scrollbars.getScrollTop() > offset;

        if (needScrollToTop || needScrollToBottom) {
            scrollbars.scrollTop(offset);
        }
    }

    render() {
        const {
            isShowSuggestion: isShowSuggestionState,
            highlightedIndex,
        } = this.state;
        const {
            value: inputValue, suggestions, hasError, errorText, disabled,
            placeholder,
        } = this.props;

        const haveSuggestions = suggestions && suggestions.length >= 1;
        const isShowSuggestion = isShowSuggestionState && inputValue !== '' && haveSuggestions;

        const classes = classNames({
            'inputStyles.input inputStyles.input--street': true,
            'inputStyles.suggestion': isShowSuggestion,
            'inputStyles.has-error': hasError,
        });

        return (
            <label
                htmlFor="street"
                styleName="inputStyles.input--has-float-label inputStyles.input-error-container"
                onKeyDown={this.handleKeyDown}
            >
                <Mobile>
                    <button
                        type="button"
                        aria-label="Ввести адрес"
                        onClick={this.handleClickStreet}
                        styleName="streetStyles.mobile-button"
                    />
                </Mobile>
                <input
                    styleName={classes}
                    id="street"
                    name="street"
                    type="text"
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={this.handleChangeStreet}
                    onBlur={this.handleBlurStreet}
                    disabled={disabled}
                    ref={this.inputRef}
                    autoComplete="new-password"
                    onClick={() => {
                        analyticService.push({ eventName: 'Checkout_Click_Address', eventLocation: '/checkout' });
                    }}
                />
                <div styleName="inputStyles.input__label">
                    {placeholder}
                </div>
                {hasError && <div styleName="inputStyles.input-error">{errorText}</div>}
                <Desktop>
                    <>
                        {isShowSuggestion && (
                            <div styleName="streetStyles.street-list">
                                <Scrollbars
                                    autoHeight
                                    autoHeightMin={SUGGESTS_MIN_HEIGHT}
                                    autoHeightMax={SUGGESTS_MAX_HEIGHT}
                                    renderThumbVertical={() => <div styleName="streetStyles.scroll-thumb" />}
                                    ref={this.scrollbarsRef}
                                >
                                    <div ref={this.streetListRef}>
                                        <AddressSuggestions
                                            suggestions={suggestions}
                                            highlightedIndex={highlightedIndex}
                                            onClickSuggestion={this.handleSelectStreet}
                                        />
                                    </div>
                                </Scrollbars>
                            </div>
                        )}
                        {isShowSuggestion && (
                            <button
                                type="button"
                                aria-label="Скрыть подсказки"
                                styleName="streetStyles.street-list-overlay"
                                onClick={this.handleCloseOutSuggestion}
                            />
                        )}
                    </>
                </Desktop>
            </label>
        );
    }
}

StreetInput.propTypes = {
    value: PropTypes.string.isRequired,
    suggestions: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
        }).isRequired,
    ).isRequired,
    hasError: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    errorText: PropTypes.string,
    placeholder: PropTypes.string,
};

const StreetInputFC = (props) => {
    const {
        hasError = false,
        onClick = () => { },
        onBlur = () => { },
        disabled = false,
        errorText = '',
        placeholder = 'Улица, дом',
    } = props || {};

    return (
        <StreetInput
            {...props}
            hasError={hasError}
            onClick={onClick}
            onBlur={onBlur}
            disabled={disabled}
            errorText={errorText}
            placeholder={placeholder}
        />
    );
};

export default StreetInputFC;
